import {
  REQUEST_PROFILE_EXPERTS,
  RESPONSE_PROFILE_EXPERTS,
  FAILURE_PROFILE_EXPERTS,
  GLOBAL_KEYWORD_CHANGE,
  SET_ZERO,
  INCREMENT,
  INCREMENT_COLLAB,
  SET_ZERO_COLLAB
} from "../../actions/types";
import { EXPERTS_PROFILE_SEARCH_API } from "../../constants/_api";
import query from "./query";
import asyncActionErrorHandler from "../../utils/asyncActionErrorHandler";

const dispatchGlobalKeywordChange = (dispatch, payload) =>
  dispatch({
    type: GLOBAL_KEYWORD_CHANGE,
    payload
  });

const dispatchRequest = (dispatch, payload) =>
  dispatch({
    type: REQUEST_PROFILE_EXPERTS,
    payload
  });

const dispatchResponse = (dispatch, payload) =>
  dispatch({
    type: RESPONSE_PROFILE_EXPERTS,
    payload
  });

const dispatchFailure = (dispatch, payload) =>
  dispatch({
    type: FAILURE_PROFILE_EXPERTS,
    payload
  });

export const getProfilesSuggest = (keyword, token) =>
  asyncActionErrorHandler(async dispatch => {
    if (!keyword) {
      return;
    }

    //DISPATCH GLOBAL KEYWORD CHANGE
    dispatchGlobalKeywordChange(dispatch, { keyword });

    dispatchRequest(dispatch, { keyword });

    let requestTime= Date.now()
    let url = `${EXPERTS_PROFILE_SEARCH_API}?q=${keyword}`;
    let result = await query(url, token);
    result = await result.json();
    result.keyword = keyword;

    if (result.body.suggestions.length > 0) {
      dispatch({
        type: SET_ZERO_COLLAB
      });
    } else if (result.body.suggestions.length == 0) {
      dispatch({
        type: INCREMENT_COLLAB
      });
    }

    if (result.message === "SUCCESS") {
      if (result.body.suggestions.length > 0) {
        let ResultFound = "Yes";
        let responseTime = Date.now();
        let TimeTaken = (responseTime - requestTime) / 1000;
        let RequestTime = new Date().toTimeString();
        let ResponseTime = new Date().toTimeString();
        console.log("yes");
        TimeTaken = TimeTaken + "seconds";
        result.body = {
          ...result.body,
          ResultFound,
          keyword,
          RequestTime,
          ResponseTime,
          TimeTaken
        };
      } else if (result.body.suggestions.length == 0) {
        let responseTime = Date.now();
        let TimeTaken = (responseTime - requestTime) / 1000;
        let RequestTime = new Date().toTimeString();
        let ResponseTime = new Date().toTimeString();
        console.log("No");
        let ResultFound = "No";
        TimeTaken = TimeTaken + "seconds";
        result.body = {
          ...result.body,
          ResultFound,
          keyword,
          RequestTime,
          ResponseTime,
          TimeTaken
        };
      }

      dispatchResponse(dispatch, result.body);
    } else if(result.message === "FAILED"){
      let responseTime = Date.now();
        let TimeTaken = (responseTime - requestTime) / 1000;
        let RequestTime = new Date().toTimeString();
        let ResponseTime = new Date().toTimeString();
        console.log("No");
        let ResultFound = "No";
        TimeTaken = TimeTaken + "seconds";
        result.body = {
          ...result.body,
          ResultFound,
          keyword,
          RequestTime,
          ResponseTime,
          TimeTaken
        };
      dispatchFailure(dispatch, result.body);

    }
  }, dispatchFailure);
